import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
  },
  backButton: {
    alignSelf: 'flex-start',
    display: 'flex',
    gap: anatomy['space-4'],
    alignItems: 'center',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.accentText,
    cursor: 'pointer',
    maxWidth: 'max-content',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: anatomy['size-12'],
  },
  title: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
  },
  actions: {
    display: 'flex',
    gap: anatomy['size-8'],
    ':not(#__unused__) button': {
      padding: '8px 20px',
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-32'],
  },
  fieldset: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-8'],
    alignItems: 'flex-start',
  },
  fieldsetInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-4'],
  },
  label: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
  },
  description: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.secondaryText,
  },
  switcher: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    ':not(#__unused__) input[type="checkbox"]:not(:checked)::before': {
      backgroundColor: `${colors.primaryIcon} !important`,
    },
  },
  switcherLabel: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.primaryText,
  },
});
